import styled from "@emotion/styled";
const Skeleton = {
    SkeletonPulse: styled.div `
    background: ${({ theme }) => theme.color.backgroundBrand};
    width: ${(props) => props.width};
    height: ${(props) => props.height};
    animation: sweep 5s ease-in-out infinite alternate;

    @keyframes sweep {
      0% {
        opacity: 0.5;
      }
      100% {
        opacity: 1;
      }
    }
  `,
    Wrapper: styled.div `
    width: 100%;
    height: 100%;
    grid-column: 2/2;
    grid-row: 1/5;
  `,
    Header: styled.div `
    padding: 1em 0;
    border-bottom: 0.1em solid rgba(6, 6, 7, 0.08);
    margin-bottom: 2em;
  `,
    Line: styled.div `
    display: flex;
    margin-bottom: 2em;
    flex-direction: row;
    gap: 20px;
  `,
    LineWrapper: styled.div `
    width: 100%;
    height: 100%;
  `,
    Spacer: styled.div `
    margin-bottom: 0.5em;
  `,
};
export default Skeleton;
//# sourceMappingURL=Skeleton.styled.js.map